import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { DocumentosSearchResponse, TipoDocumento } from 'src/app/pages/configuracion/Envios/documentos/models/tipo-documento';
import { environment } from 'src/environments/environment';
import { IRecuperarTiposDocumentoService } from './ports/i-recuperar-tipos-documento-service';
import { OrdenColumna } from 'src/app/shared/models/orden-columna';
import { FiltroDocs, FiltroEmpleado } from 'src/app/shared/models/filtros';
import { FiltroSqp } from 'src/app/shared/components/sqp-components/sqpFiltroSuperior/models/filtro-sqp';

@Injectable({
  providedIn: 'root'
})
export class RecuperaTipoDocumentoMockService implements IRecuperarTiposDocumentoService{

  constructor(private http: HttpClient) { }

  guardaDocumento(data: any): Observable<any> {
    throw new Error('Method not implemented.');
  }

  // getTipoDocumentos2(): Observable<TipoDocumento[]> {

  //   const headers = new HttpHeaders()
  //   .set('content-type', 'application/json')

  //   return this.http.get<DocumentosSearchResponse>(`${environment.ApiDocumentosMock}`, {headers})
  //     .pipe(
  //       map(resp => {
  //           let documentos: TipoDocumento[] = resp.datos;
  //           return documentos;
  //         }
  //       )
  //   );
  // }

  getTipoDocumentos(filtrosSqp: FiltroSqp[], pageNumber:number, pageSize:number = 50, orden: OrdenColumna = {campoOrden:'', orden:''}): Observable<TipoDocumento[]> {

      let url;
      if(pageNumber == 0){ pageNumber = 1; }
      if(pageNumber == 1){ url = environment.ApiDocsMock1; }
      else if(pageNumber == 2){ url = environment.ApiDocsMock2; }
      else if(pageNumber == 3){ url = environment.ApiDocsMock3; }
      else return of([]);
      return this.http.get<TipoDocumento[]>(url)
        .pipe(
          map(resp => {
            let documentos: TipoDocumento[] = resp;
              return documentos;
            }
          )
      );
  }
}
